import React, { useEffect, useState, useRef } from 'react';
import { gsap } from 'gsap';
import Globe from 'globe.gl';
import Modal from './Modal';
import './Slide7.css';

const Slide7Component = () => {
  const [typedText, setTypedText] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const globeEl = useRef();

  const openModal = (memberType) => {
    setModalContent(getModalContent(memberType));
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const getModalContent = (type) => {
    const contents = {
      robin: {
        title: 'Robin BITTNER',
        icon: 'bi bi-person-circle',
        content: (
          <>
            <div className="modal-section">
              <h3><i className="bi bi-mortarboard"></i> Formation</h3>
              <p>
                Robin BITTNER est étudiant à <strong>Télécom Physique Strasbourg</strong>, une école d'ingénieurs
                reconnue pour son excellence dans les domaines des télécommunications, de la photonique et des
                technologies de l'information. Située dans la capitale européenne, cette école forme des ingénieurs
                hautement qualifiés capables de relever les défis technologiques de demain.
              </p>
              <p>
                Son parcours académique à Strasbourg lui a permis de développer une expertise technique solide,
                particulièrement dans les domaines liés aux réseaux, aux systèmes embarqués et à la sécurité
                informatique, des compétences essentielles pour le développement de MarIAne.
              </p>
            </div>

            <img
              src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80"
              alt="Télécom Physique Strasbourg"
              className="modal-image"
            />

            <div className="modal-section">
              <h3><i className="bi bi-code-slash"></i> Contribution au projet</h3>
              <p>
                Au sein de l'équipe MarIAne, Robin apporte son expertise technique et sa vision innovante pour
                construire un moteur de recherche véritablement respectueux de la vie privée. Sa contribution
                est essentielle dans l'architecture du système et l'implémentation des fonctionnalités de sécurité
                avancées qui font la force de MarIAne.
              </p>
              <p>
                Passionné par les technologies open source et les problématiques de confidentialité, Robin incarne
                parfaitement les valeurs éthiques du projet. Son approche pragmatique et son souci du détail
                garantissent que chaque fonctionnalité de MarIAne est développée avec le plus haut niveau de
                qualité et de sécurité.
              </p>
            </div>

            <div className="modal-highlight">
              <i className="bi bi-envelope"></i> Contact : robin@robin2dev.com
            </div>

            <img
              src="https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800&q=80"
              alt="Développement et innovation"
              className="modal-image"
            />
          </>
        )
      },
      gabriel: {
        title: 'Gabriel DÉROZIER-PRIOTTO',
        icon: 'bi bi-person-circle',
        content: (
          <>
            <div className="modal-section">
              <h3><i className="bi bi-mortarboard"></i> Formation</h3>
              <p>
                Gabriel DÉROZIER-PRIOTTO poursuit ses études à <strong>Bordeaux INP - ENSEIRB-MATMECA</strong>,
                une des écoles d'ingénieurs les plus prestigieuses de France dans les domaines de l'électronique,
                de l'informatique, des télécommunications et de la mécanique. Cette formation d'excellence lui
                confère une vision pluridisciplinaire unique, essentielle pour un projet aussi ambitieux que MarIAne.
              </p>
              <p>
                Son parcours à l'ENSEIRB-MATMECA lui a permis de maîtriser les technologies de pointe en
                informatique, en intelligence artificielle et en traitement de données, tout en développant
                une compréhension profonde des enjeux éthiques liés au numérique. Cette double compétence
                technique et éthique est au cœur de sa contribution au projet.
              </p>
            </div>

            <img
              src="https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=800&q=80"
              alt="Bordeaux INP ENSEIRB-MATMECA"
              className="modal-image"
            />

            <div className="modal-section">
              <h3><i className="bi bi-code-slash"></i> Contribution au projet</h3>
              <p>
                Gabriel joue un rôle central dans le développement de MarIAne, apportant son expertise en
                architecture logicielle et en systèmes distribués. Sa capacité à concevoir des solutions
                techniques robustes et scalables garantit que MarIAne peut répondre aux besoins des utilisateurs
                tout en maintenant les standards les plus élevés en matière de performance et de fiabilité.
              </p>
              <p>
                Convaincu que la technologie doit servir l'humain et non l'inverse, Gabriel s'investit pleinement
                dans la mission de MarIAne : créer un moteur de recherche qui respecte véritablement la vie privée
                des utilisateurs. Son engagement éthique et sa rigueur technique sont des piliers fondamentaux du projet.
              </p>
            </div>

            <div className="modal-highlight">
              <i className="bi bi-envelope"></i> Contact : Gabriel.Derozier--Priotto@bordeaux-inp.fr
            </div>

            <img
              src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80"
              alt="Collaboration et innovation"
              className="modal-image"
            />
          </>
        )
      },
      arthur: {
        title: 'Arthur PICHAUT',
        icon: 'bi bi-person-circle',
        content: (
          <>
            <div className="modal-section">
              <h3><i className="bi bi-mortarboard"></i> Formation</h3>
              <p>
                Arthur PICHAUT est élève ingénieur à l'<strong>École des Mines de Saint-Étienne</strong>,
                une institution centenaire reconnue mondialement pour son excellence académique et sa capacité
                à former des ingénieurs capables d'innover et de transformer les industries. L'École des Mines
                est réputée pour son approche holistique de la formation, alliant excellence technique,
                innovation et responsabilité sociale.
              </p>
              <p>
                Le cursus de l'École des Mines a permis à Arthur de développer une expertise technique
                approfondie tout en cultivant une vision stratégique des enjeux technologiques contemporains.
                Cette formation d'excellence lui confère les compétences nécessaires pour contribuer
                significativement à un projet innovant comme MarIAne.
              </p>
            </div>

            <img
              src="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800&q=80"
              alt="École des Mines de Saint-Étienne"
              className="modal-image"
            />

            <div className="modal-section">
              <h3><i className="bi bi-code-slash"></i> Contribution au projet</h3>
              <p>
                Au sein de l'équipe MarIAne, Arthur apporte sa vision innovante et sa capacité à résoudre
                des problèmes complexes. Son approche méthodique et son expertise technique contribuent
                directement à l'élaboration de solutions robustes et efficaces pour les fonctionnalités
                critiques du moteur de recherche.
              </p>
              <p>
                Animé par la conviction que la technologie peut être un vecteur de changement positif,
                Arthur s'investit pleinement dans la mission de MarIAne. Son engagement pour une technologie
                éthique et son sens aigu de la qualité garantissent que chaque aspect du projet respecte
                les valeurs fondamentales de transparence et de respect de la vie privée.
              </p>
            </div>

            <div className="modal-highlight">
              <i className="bi bi-envelope"></i> Contact : arthurpichaut@gmail.com
            </div>

            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80"
              alt="Innovation et travail d'équipe"
              className="modal-image"
            />
          </>
        )
      },
      annibal: {
        title: 'Annibal KOECHLIN',
        icon: 'bi bi-person-circle',
        content: (
          <>
            <div className="modal-section">
              <h3><i className="bi bi-mortarboard"></i> Formation</h3>
              <p>
                Annibal KOECHLIN poursuit sa formation à <strong>Grenoble INP - Ensimag</strong>,
                l'une des écoles d'ingénieurs les plus prestigieuses de France en informatique et mathématiques
                appliquées. Située au cœur de l'écosystème technologique grenoblois, Ensimag forme les futurs
                experts en informatique, data science et intelligence artificielle.
              </p>
              <p>
                Son parcours à Ensimag lui a permis de développer une expertise pointue en algorithmique,
                en intelligence artificielle et en génie logiciel. Cette formation d'excellence, reconnue
                internationalement, lui confère les compétences techniques de haut niveau nécessaires pour
                contribuer aux aspects les plus avancés de MarIAne, notamment l'intégration des modèles IA
                et l'optimisation des algorithmes de recherche.
              </p>
            </div>

            <img
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80"
              alt="Grenoble INP Ensimag"
              className="modal-image"
            />

            <div className="modal-section">
              <h3><i className="bi bi-code-slash"></i> Contribution au projet</h3>
              <p>
                Annibal joue un rôle clé dans le développement des composants d'intelligence artificielle
                de MarIAne. Son expertise en machine learning et en traitement du langage naturel est
                essentielle pour créer des modèles IA performants tout en garantissant qu'ils fonctionnent
                localement, sans jamais compromettre la vie privée des utilisateurs.
              </p>
              <p>
                Passionné par l'intersection entre IA et éthique, Annibal travaille à démontrer qu'il est
                possible de construire des systèmes intelligents respectueux de la vie privée. Sa rigueur
                scientifique et son engagement pour une technologie responsable font de lui un contributeur
                essentiel à la mission de MarIAne de révolutionner la recherche web éthique.
              </p>
            </div>

            <div className="modal-highlight">
              <i className="bi bi-envelope"></i> Contact : koechlin.annibal@gmail.com
            </div>

            <img
              src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&q=80"
              alt="Intelligence artificielle et innovation"
              className="modal-image"
            />
          </>
        )
      },
      dcs: {
        title: 'Data Control Solutions',
        icon: 'bi bi-building',
        content: (
          <>
            <div className="modal-section">
              <h3><i className="bi bi-briefcase"></i> Bureau d'Études & Deep Tech</h3>
              <p>
                <strong>Data Control Solutions (DCS)</strong> est un bureau d'études spécialisé dans les nouvelles
                technologies, la deep tech et l'intelligence artificielle générative. Avec plus de 15 ans d'expérience,
                DCS se positionne comme un acteur majeur dans la conception, le développement et la production de solutions
                logicielles innovantes, de la phase de conception initiale jusqu'à la mise en production complète.
              </p>
              <p>
                En tant qu'éditeur et porteur du projet MarIAne, DCS apporte son expertise technique approfondie et sa
                vision stratégique pour faire de ce moteur de recherche éthique une réalité concrète. L'entreprise incarne
                parfaitement les valeurs du projet : innovation technologique au service de l'utilisateur, transparence
                totale et respect absolu de la vie privée.
              </p>
            </div>

            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
              alt="Innovation et technologies"
              className="modal-image"
            />

            <div className="modal-section">
              <h3><i className="bi bi-gear-wide-connected"></i> Expertises Technologiques</h3>
              <p>
                DCS maîtrise l'ensemble de la stack technologique moderne, du frontend aux infrastructures cloud en passant
                par l'intelligence artificielle. L'entreprise développe des solutions SaaS complètes en utilisant les
                technologies les plus avancées : React, Vue.js, Node.js, Python, et intègre des modèles d'IA de pointe
                (GPT, Claude, LLaMA) dans des applications concrètes.
              </p>
              <p>
                Cette expertise multidisciplinaire permet à DCS d'accompagner le projet MarIAne sur tous les aspects
                techniques : architecture système, développement des modèles IA locaux, implémentation des fonctionnalités
                de sécurité avancées, et optimisation des performances. DCS ne se contente pas de développer, l'entreprise
                conçoit des solutions robustes, scalables et pérennes.
              </p>
            </div>

            <div className="modal-highlight">
              <i className="bi bi-quote"></i> "Produire des solutions logicielles complètes qui respectent véritablement
              les utilisateurs : c'est l'engagement de DCS et la raison d'être du projet MarIAne."
            </div>

            <img
              src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&q=80"
              alt="Développement et innovation"
              className="modal-image"
            />

            <div className="modal-section">
              <h3><i className="bi bi-rocket-takeoff"></i> Vision & Mission</h3>
              <p>
                La vision de DCS est claire : démontrer qu'il est possible de créer des technologies de pointe sans
                sacrifier l'éthique et le respect des utilisateurs. MarIAne incarne parfaitement cette philosophie en
                prouvant qu'un moteur de recherche intelligent peut exister sans modèle économique basé sur l'exploitation
                des données personnelles.
              </p>
              <p>
                En portant le projet MarIAne, DCS s'engage à fournir l'infrastructure technique, l'expertise en IA,
                et le support nécessaire pour faire émerger une alternative crédible aux géants du web. L'entreprise
                assure également la pérennité du projet en apportant les ressources et la vision stratégique nécessaires
                à son développement à long terme.
              </p>
            </div>

            <div className="modal-section">
              <h3><i className="bi bi-people"></i> Collaboration Académique</h3>
              <p>
                Le choix de DCS de collaborer avec quatre étudiants de grandes écoles d'ingénieurs françaises
                (Télécom Physique Strasbourg, Bordeaux INP, École des Mines, Grenoble INP) n'est pas anodin. Cette
                approche collaborative permet de combiner l'expertise industrielle de DCS avec la fraîcheur et l'innovation
                apportées par de jeunes talents formés aux dernières technologies.
              </p>
              <p>
                Cette synergie entre le monde professionnel et académique garantit que MarIAne bénéficie à la fois
                de standards de qualité professionnels et d'une approche innovante sans compromis. C'est cette combinaison
                unique qui fait la force du projet et assure son potentiel de disruption dans le domaine de la recherche web.
              </p>
            </div>

            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
              alt="Collaboration et travail d'équipe"
              className="modal-image"
            />
          </>
        )
      }
    };

    return contents[type];
  };

  useEffect(() => {
    // Coordonnées des villes
    const cities = [
      { lat: 48.5734, lng: 7.7521, name: 'Strasbourg - Robin BITTNER', color: '#00d4ff' },
      { lat: 44.8378, lng: -0.5792, name: 'Bordeaux - Gabriel DÉROZIER-PRIOTTO', color: '#00d4ff' },
      { lat: 45.4397, lng: 4.3872, name: 'Saint-Étienne - Arthur PICHAUT', color: '#00d4ff' },
      { lat: 45.1885, lng: 5.7245, name: 'Grenoble - Annibal KOECHLIN', color: '#00d4ff' },
      { lat: 48.8566, lng: 2.3522, name: 'Paris - DCS', color: '#ffa500' }
    ];

    // Initialize Globe.gl avec animation des pointeurs
    const globe = Globe()
      (globeEl.current)
      .globeImageUrl('//unpkg.com/three-globe/example/img/earth-night.jpg')
      .backgroundColor('rgba(0,0,0,0)')
      .width(500)
      .height(500)
      .pointsData(cities)
      .pointAltitude(0.01)
      .pointRadius(0.3)
      .pointColor('color')
      .pointLabel('name')
      .pointsMerge(true)
      .ringsData(cities)
      .ringColor((d) => d.color)
      .ringMaxRadius(2)
      .ringPropagationSpeed(2)
      .ringRepeatPeriod(2000);

    // Configure camera - zoom très rapproché sur la France
    globe.pointOfView({ lat: 46.5, lng: 2.5, altitude: 0.4 }, 1000);

    // Bloquer la rotation et le zoom
    globe.controls().enableRotate = false;
    globe.controls().enableZoom = false;
    globe.controls().autoRotate = false;

    const tl = gsap.timeline();

    tl.set('.slide7-header', { opacity: 1 });

    tl.add(() => {
      const text = "Qui est derrière MarIAne ?";
      let index = 0;
      const typeInterval = setInterval(() => {
        if (index <= text.length) {
          setTypedText(text.slice(0, index));
          index++;
        } else {
          clearInterval(typeInterval);
        }
      }, 50);
    }, '+=0.8');

    tl.to('.slide7-search-button', {
      scale: 1.1,
      boxShadow: '0 0 40px rgba(0, 212, 255, 0.8)',
      duration: 0.3,
      repeat: 1,
      yoyo: true
    }, '+=2');

    tl.fromTo('.slide7-main-title',
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }
    , '+=0.3');

    tl.fromTo('.slide7-separator',
      { opacity: 0, scaleX: 0 },
      { opacity: 1, scaleX: 1, duration: 0.8, ease: 'power2.inOut' }
    , '-=0.4');

    tl.fromTo('.team-section',
      { opacity: 0, y: 50, scale: 0.95 },
      { opacity: 1, y: 0, scale: 1, duration: 0.7, stagger: 0.15, ease: 'power2.out' }
    , '+=0.2');

    return () => tl.kill();
  }, []);

  return (
    <div className="slide-content slide-7-transition">
      <header className="slide7-header">
        <div className="slide7-header-content">
          <div className="slide7-logo-small">
            MAR<span className="neon-text">IA</span>NE
          </div>
          <form className="slide7-search-form">
            <div className="slide7-search-box">
              <input
                type="text"
                className="slide7-search-input"
                placeholder="Rechercher..."
                value={typedText}
                readOnly
              />
              <button type="button" className="slide7-search-button">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              </button>
            </div>
          </form>
        </div>
      </header>

      <div className="slide7-content">
        <div className="slide7-main-title">
          <h1 className="slide7-h1">L'Équipe</h1>
          <p className="slide7-sub">4 Étudiants, 4 Universités, 1 Vision</p>
        </div>

        <div className="slide7-separator"></div>

        <div className="team-content-grid">
          <div className="globe-container">
            <div ref={globeEl}></div>
          </div>

          <div className="team-buttons-container">
            <button className="team-member-button" onClick={() => openModal('robin')}>
              <i className="bi bi-person-circle"></i>
              <span>Robin BITTNER - Strasbourg</span>
              <i className="bi bi-arrow-right"></i>
            </button>

            <button className="team-member-button" onClick={() => openModal('gabriel')}>
              <i className="bi bi-person-circle"></i>
              <span>Gabriel DÉROZIER-PRIOTTO - Bordeaux</span>
              <i className="bi bi-arrow-right"></i>
            </button>

            <button className="team-member-button" onClick={() => openModal('arthur')}>
              <i className="bi bi-person-circle"></i>
              <span>Arthur PICHAUT - Saint-Étienne</span>
              <i className="bi bi-arrow-right"></i>
            </button>

            <button className="team-member-button" onClick={() => openModal('annibal')}>
              <i className="bi bi-person-circle"></i>
              <span>Annibal KOECHLIN - Grenoble</span>
              <i className="bi bi-arrow-right"></i>
            </button>

            <button className="team-member-button dsc-button" onClick={() => openModal('dcs')}>
              <i className="bi bi-building"></i>
              <span>DCS - Data Control Solutions - Paris</span>
              <i className="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>

      {modalContent && (
        <Modal
          isOpen={modalOpen}
          onClose={closeModal}
          title={modalContent.title}
          icon={modalContent.icon}
          content={modalContent.content}
        />
      )}
    </div>
  );
};

export default Slide7Component;
